import { render, staticRenderFns } from "./CFileInput.vue?vue&type=template&id=7352c7a3&scoped=true"
import script from "./CFileInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./CFileInput.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CFileInput.vue?vue&type=style&index=0&id=7352c7a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7352c7a3",
  null
  
)

export default component.exports